<template>
    <div class="codics-home-body">
        <el-carousel v-show="!isPhone" class="codics-home-lunbo" height="100%" :autoplay="true" :interval="3000">
            <!-- <el-carousel-item>
                <el-image style="height: 100%;width: 100%;position: relative;float: left;"
                    src="https://cp-static.wangcaio2o.com/Public/Image/cp_index/banner_02/2024-01/banner_bg.png"
                    fit="cover"></el-image>
                <el-image
                    style="height: 195px;width: 278px;position: absolute;margin: auto;top: -50px;bottom:0;left: 355px;right: 0;transform: translate3d(0,0,0);will-change: transform;animation: lunBoOne 3s linear infinite;"
                    src="https://cp-static.wangcaio2o.com/Public/Image/cp_index/banner_02/2024-01/ele_01.png"
                    fit="fill"></el-image>
                <el-image
                    style="height: 63px;width: 72px;position: absolute;margin: auto;left: 160px;right: 0;top: -25px;bottom: 0;transform: translate3d(0,0,0);will-change: transform;animation: kaQuan 3s linear infinite;overflow: hidden;"
                    src="https://cp-static.wangcaio2o.com/Public/Image/cp_index/banner_02/2024-01/ele_02.png"></el-image>
            </el-carousel-item>
            <el-carousel-item>
                <el-image style="height: 100%;width: 100%;position: relative;float: left;"
                    src="https://cp-static.wangcaio2o.com/Public/Image/cp_index/banner_03/2024-01/banner_bg.png"
                    fit="cover"></el-image>
                <div
                    style="height: 265px;width: 299px;position: absolute;margin: auto;left: 0;right: -730px;top: 90px;bottom: 0;transform: translate3d(0,0,0);will-change: transform;animation: lunBoOne 3s linear infinite;">
                    <el-image style="position: absolute;top: 73px;left: -15px;z-index: 1;"
                        src="https://cp-static.wangcaio2o.com/Public/Image/cp_index/banner_03/2024-01/ele_01_01.png"></el-image>
                    <el-image style="position: absolute;"
                        src="https://cp-static.wangcaio2o.com/Public/Image/cp_index/banner_03/2024-01/ele_01_02.png"></el-image>
                    <el-image style="position: absolute;right: 55px;bottom: 160px;"
                        src="https://cp-static.wangcaio2o.com/Public/Image/cp_index/banner_03/2024-01/ele_01_03.png"></el-image>
                    <el-image style="position: absolute;top: 20px;left: -10px;"
                        src="https://cp-static.wangcaio2o.com/Public/Image/cp_index/banner_03/2024-01/ele_01_04.png"></el-image>
                    <el-image style="position: absolute;top: 10px;"
                        src="https://cp-static.wangcaio2o.com/Public/Image/cp_index/banner_03/2024-01/ele_02_01.png"></el-image>
                    <el-image style="position: absolute;left: 50px;top: 130px;"
                        src="https://cp-static.wangcaio2o.com/Public/Image/cp_index/banner_03/2024-01/ele_02_02.png"></el-image>
                    <el-image style="position: absolute;right: 13px;top: 24px;"
                        src="https://cp-static.wangcaio2o.com/Public/Image/cp_index/banner_03/2024-01/ele_02_03.png"></el-image>
                    <el-image
                        style="position: absolute;right: 130px;top: -28px;z-index: 6;transform: translate3d(0,0,0);will-change: transform;animation: kaPian 3s linear infinite;"
                        src="https://cp-static.wangcaio2o.com/Public/Image/cp_index/banner_03/2024-01/ele_03_01.png"></el-image>
                    <el-image
                        style="position: absolute;right: 120px;top: -33px;z-index: 5;transform: translate3d(0,0,0);will-change: transform;animation: kaPian 3s linear infinite;animation-delay: .1s;"
                        src="https://cp-static.wangcaio2o.com/Public/Image/cp_index/banner_03/2024-01/ele_03_02.png"></el-image>
                    <el-image
                        style="position: absolute;right: 110px;top: -38px;z-index: 4;transform: translate3d(0,0,0);will-change: transform;animation: kaPian 3s linear infinite;animation-delay: .2s;"
                        src="https://cp-static.wangcaio2o.com/Public/Image/cp_index/banner_03/2024-01/ele_03_03.png"></el-image>
                    <el-image style="position: absolute;right: 92px;top: 43px;z-index: 7;"
                        src="https://cp-static.wangcaio2o.com/Public/Image/cp_index/banner_03/2024-01/ele_03_04.png"></el-image>
                    <el-image style="position: absolute;right: 93px;top: 22px;z-index: 2;"
                        src="https://cp-static.wangcaio2o.com/Public/Image/cp_index/banner_03/2024-01/ele_03_05.png"></el-image>
                    <el-image style="position: absolute;right: 51px;top: -87px;z-index: 1;"
                        src="https://cp-static.wangcaio2o.com/Public/Image/cp_index/banner_03/2024-01/ele_03_06.png"></el-image>
                    <el-image style="position: absolute;right: 128px;top: 75px;z-index: 0;"
                        src="https://cp-static.wangcaio2o.com/Public/Image/cp_index/banner_03/2024-01/ele_03_s.png"></el-image>
                </div>
            </el-carousel-item> -->
            <el-carousel-item v-for="(item, index) in lunboDate" :key="index">
                <div v-html="item.code"
                    style="height: 100%;width: 100%;position: relative;float: left;box-sizing: border-box;"></div>
            </el-carousel-item>
        </el-carousel>
        <el-image v-show="isPhone" style="height: fit-content;width: 100%;position: relative;float: left;margin-top: 60px;user-select: none;" src="https://cdn.posto.cn/huayuan/img/24-4-9-%E7%BA%BF%E4%B8%8A%E5%88%B8%E5%85%91%E6%8D%A2%E6%B5%81%E7%A8%8B.jpg" fit="fill"></el-image>
        <!-- <div class="codics-home-card-box">
            <div class="codics-home-card" v-for="item in cardData" :key="item.id">
                <div class="codics-home-card-line">
                    <el-image class="codics-home-card-line-icon" :src="item.icon"></el-image>
                    <div class="codics-home-card-line-title">{{ item.title }}</div>
                </div>
                <div class="codics-home-card-line-txt">{{ item.detail }}</div>
            </div>
        </div> -->
        <!-- <el-divider class="codics-home-divider">多场景电子券发放</el-divider>
        <div class="codics-home-divider-hint">【场景1：线上赠送，线下核销】</div>
        <el-image class="codics-home-divider-img" src="https://cdn.posto.cn/img/s3_img1.png" fit="fill"></el-image>
        <div class="codics-home-divider-hint">【场景2：企业福利，与周边商家合作】</div>
        <el-image class="codics-home-divider-img" src="https://cdn.posto.cn/img/s3_img2.png" fit="fill"></el-image>
        <div class="codics-home-divider-hint">【场景3：福利发放-线下】</div>
        <el-image class="codics-home-divider-img" src="https://cdn.posto.cn/img/s3_img3.png" fit="fill"></el-image>
        <div class="codics-home-divider-hint">【场景4：福利发放-线下】</div>
        <el-image class="codics-home-divider-img" src="https://cdn.posto.cn/img/s3_img4.png" fit="fill"></el-image>
        <div class="codics-home-divider-hint">【场景5：福利发放-线下】</div>
        <el-image class="codics-home-divider-img" src="https://cdn.posto.cn/img/s3_img5.png" fit="fill"></el-image>
        <div class="codics-home-divider-hint">【场景6：福利发放-线下】</div>
        <el-image class="codics-home-divider-img" src="https://cdn.posto.cn/img/s3_img6.png" fit="fill"></el-image>
        <div class="codics-home-divider-hint">【场景7：福利发放-线下】</div>
        <el-image class="codics-home-divider-img" src="https://cdn.posto.cn/img/s3_img7.png" fit="fill"></el-image>
        <el-button class="codics-home-divider-" type="primary" plain>主要按钮</el-button> -->
        <div class="codics-home-totop-box">
            <div class="codics-home-totop-card" style="top: 0;" v-show="showToTop" @click="toTop">
                <div class="codics-home-totop-card-icon iconfont">&#xe846;</div>
            </div>
            <!-- <div class="codics-home-totop-card codics-home-totop-card-qr" style="bottom: 0;">
                <div class="codics-home-totop-card-icon iconfont">&#xe747;</div>
            </div>
            <el-image class="codics-home-totop-card-qrcode"
                src="data:image/png;base64,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"
                fit="fill"></el-image> -->
        </div>
        <!-- <div class="codics-home-kf-box">
            <el-tooltip class="item" effect="dark" content="嘿，我来帮您！" placement="right">
                <el-image class="codics-home-kf-box-image"
                    src="http://demo.sucaihuo.com/jquery/22/2229/demo/images/en_3.png"
                    @click="showKfDialog();"></el-image>
            </el-tooltip>
        </div> -->
        <HomeFooter style="height:fit-content;width: 100%;position: relative;float: left;"></HomeFooter>
        <!-- <WebDialog height="60%" width="50%" ref="kfDialog" title="客服咨询"></WebDialog> -->
    </div>
</template>

<script>
// import WebDialog from '@/components/WebDialog';
import HomeFooter from '@/components/HomeFooter';
import { listLunbo2 } from '@/api';
export default {
    name: 'ShopIndex',
    data() {
        return {
            cardData: [
                {
                    id: 1,
                    icon: 'https://cdn.posto.cn/huayuan/img/%E5%BA%94%E7%94%A82.png',
                    title: '代金券',
                    detail: '线上线下场景,抵扣同样等值的现金的券',
                    url: ''
                },
                {
                    id: 2,
                    icon: 'https://cdn.posto.cn/huayuan/img/%E5%BA%94%E7%94%A82.png',
                    title: '折扣券',
                    detail: '线上线下场景,按折扣比例抵扣相应金额的券',
                    url: ''
                },
                {
                    id: 3,
                    icon: 'https://cdn.posto.cn/huayuan/img/%E5%BA%94%E7%94%A82.png',
                    title: '提领券',
                    detail: '线上线下场景,直接领取制定商品的券',
                    url: ''
                },
                {
                    id: 4,
                    icon: 'https://cdn.posto.cn/huayuan/img/%E5%BA%94%E7%94%A82.png',
                    title: '计次卡',
                    detail: '线上线下场景,按照实际使用次数从剩余次数中扣减，直至次数用完',
                    url: ''
                }
            ],
            showToTop: false,
            lunboDate: [],
            isPhone: false
        };
    },

    mounted() {
        // 监听页面滚动事件
        window.addEventListener("scroll", this.showTop);

        this.listLunboFuc();

        this.isPhone = document.body.clientWidth<=768

        window.onresize = () => {
            return (() => {
                this.isPhone = document.body.clientWidth<=768
            })()
        }

    },

    methods: {
        showTop() {
            // 获取当前滚动条向下滚动的距离
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            // 当页面滚动到高度300px处时，显示返回顶部
            if (scrollTop > 300) {
                this.showToTop = true;
            } else {
                this.showToTop = false;
            }
        },
        toTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },
        showKfDialog() {

            this.$refs.kfDialog.toggleShow();

        },
        handleClose(done) {
            done();
        },
        async listLunboFuc() {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await listLunbo2();

            loading.close();

            if (data.code == 200) {

                this.lunboDate = data.data;

            } else {

                this.$message.error(data.message);

            }

        },
    },

    components: {
        HomeFooter,
        // WebDialog
    }
};
</script>

<style lang="css">
.codics-header-bar {
    background: rgba(0, 0, 0, 0) !important;
}

/* 主页内容 */
.codics-home-body {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    margin-top: -60px;
}

/* 主页轮播 */
.codics-home-lunbo {
    /* height: 590px; */
    height: calc(100vh - 100px);
    width: 100%;
    position: relative;
    float: left;
    margin-top: 60px;
}

/* 主页轮播指示器位置 */
.codics-home-lunbo .el-carousel__indicators--horizontal {
    bottom: 60px !important;
}

/* 主页卡片盒子 */
.codics-home-card-box {
    height: fit-content;
    width: 100%;
    max-width: 1450px;
    position: relative;
    float: left;
    left: 50%;
    transform: translateX(-50%);
    top: -57.5px;
    z-index: 100;
    box-sizing: border-box;
    padding: 0 20px 0 20px;
}

/* 主页卡片 */
.codics-home-card {
    height: 115px;
    width: calc(25% - 15px);
    position: relative;
    float: left;
    background: linear-gradient(0deg, #fff, #f3f5f8);
    border: 2px solid #FFF;
    border-radius: 3px;
    box-shadow: 8px 8px 20px 0 rgba(55, 99, 170, .1);
    cursor: pointer;
    user-select: none;
    transition: .4s;
    box-sizing: border-box;
    padding: 5px;
}

.codics-home-card:hover {
    box-shadow: 2px 2px 5px 0 rgba(55, 99, 170, .1);
}

.codics-home-card:nth-child(2),
.codics-home-card:nth-child(3),
.codics-home-card:nth-child(4) {
    margin-left: 20px;
}

.codics-home-card-line {
    height: 50px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.codics-home-card-line-icon {
    height: 100%;
    width: 50px;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 15px;
}

.codics-home-card-line-title {
    height: 50px;
    width: fit-content;
    position: relative;
    float: left;
    line-height: 50px;
    font-size: 18px;
    color: #181818;
    font-weight: 500;
}

.codics-home-card-line-txt {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    font-size: 14px;
    color: #4b5b76;
    line-height: 25px;
    box-sizing: border-box;
    padding: 0 15px 0 15px;
    top: -5px;
}

.codics-home-totop-box {
    height: 100px;
    width: 50px;
    position: fixed;
    right: 60px;
    bottom: 60px;
    box-sizing: border-box;
    z-index: 1000;
}

.codics-home-totop-card {
    height: 50px;
    width: 50px;
    position: absolute;
    left: 0;
    box-sizing: border-box;
    padding: 5px;
    user-select: none;
    cursor: pointer;
}

.codics-home-totop-card-icon {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px;
    border: 1px solid #FFF;
    box-shadow: 8px 8px 20px 0 rgba(55, 99, 170, .1);
    background: linear-gradient(0deg, #fff, #f3f5f8);
}

.codics-home-divider {
    width: 100%;
    position: relative;
    float: left !important;
    max-width: 1450px;
    left: 50%;
    transform: translateX(-50%);
}

.codics-home-divider div {
    user-select: none;
    font-size: 17px;
    color: #4b5b76;
    background-color: #f8f8f8 !important;
}

.codics-home-kf-box {
    height: 50px;
    width: 50px;
    position: fixed;
    left: 60px;
    bottom: 60px;
    box-sizing: border-box;
    padding: 5px;
    z-index: 1000;
    cursor: pointer;
    user-select: none;
}

.codics-home-kf-box-image {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    border: 1px solid #FFF;
    border-radius: 25px;
    box-shadow: 8px 8px 20px 0 rgba(55, 99, 170, .1);
    z-index: 2;
}

.codics-home-kf-box::before,
.codics-home-kf-box::after {
    content: '';
    height: 100px;
    width: 100px;
    position: absolute;
    left: -25px;
    top: -25px;
    border: 2px solid #EF2D02;
    background: rgba(239, 45, 2, 0.8);
    border-radius: 50%;
    opacity: 0;
    z-index: 1;
}

.codics-home-kf-box::before {
    background: rgba(239, 45, 2, 0.6) !important;
    -webkit-animation: homeTipOne 0.9s ease-out;
    -moz-animation: homeTipOne 0.9s ease-out;
    animation: homeTipOne 0.9s ease-out;
    -webkit-animation-iteration-count: infinite;
    -moz-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    box-shadow: 1px 1px 30px #EF2D02;
    z-index: 0;
}

.codics-home-kf-box::after {
    background: rgba(239, 45, 2, 0.6) !important;
    -webkit-animation: homeTipTwo 0.9s ease-out;
    -moz-animation: homeTipTwo 0.9s ease-out;
    animation: homeTipTwo 0.9s ease-out;
    -webkit-animation-iteration-count: infinite;
    -moz-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    box-shadow: 1px 1px 30px #EF2D02;
}

.codics-home-kf-custom-dialog {
    width: 200px;
    height: 200px;
    background-color: #333;
    border: 1px solid #ccc;
    position: absolute;
    left: 0;
    top: 0;
    /* 必须将元素定位为absolute或fixed */
}

.codics-home-divider-hint {
    height: 50px;
    width: 100%;
    position: relative;
    float: left;
    text-align: center;
    line-height: 50px;
    color: #555;
    font-weight: bolder;
    font-size: 14px;
    margin-bottom: 50px;
}

.codics-home-divider-img {
    height: fit-content;
    width: 100%;
    max-width: 1160px;
    position: relative;
    float: left;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 100px;
}

.codics-home-totop-card-qrcode {
    height: 100px;
    width: 100px;
    position: absolute;
    top: 0;
    left: -100px;
    box-sizing: border-box;
    padding: 5px;
    border: 1px solid #FFF;
    box-shadow: 8px 8px 20px 0 rgba(55, 99, 170, .1);
    background: linear-gradient(0deg, #fff, #f3f5f8);
    opacity: 0;
    pointer-events: none !important;
    transition: .4s;
}

.codics-home-totop-card-qr:hover+.codics-home-totop-card-qrcode {
    opacity: 1;
}

@keyframes lunBoOne {
    0% {
        transform: translate3d(0, 0, 0);
    }

    50% {
        transform: translate3d(0, -20px, 0);
    }

    100% {
        transform: translate3d(0, 0, 0);
    }
}

@keyframes kaQuan {
    0% {
        transform: translate3d(-70px, -35px, 0);
        opacity: 0;
    }

    25% {
        transform: translate3d(0, 0, 0);
        opacity: 1;
    }

    70% {
        transform: translate3d(0, 0, 0);
        opacity: 1;
    }

    100% {
        transform: translate3d(70px, 35px, 0);
        opacity: 0;
    }
}

@keyframes kaPian {
    0% {
        transform: translate3d(5px, -5px, -5px);
        opacity: 0;
    }

    15% {
        transform: translate3d(0, 0, 0);
        opacity: 1;
    }

    85% {
        transform: translate3d(0, 0, 0);
        opacity: 1;
    }

    100% {
        transform: translate3d(0px, 60px, 0);
        opacity: 0;
    }
}

@keyframes homeTipOne {
    0% {
        -moz-transform: scale(0);
        transform: scale(0);
        opacity: 1;
    }

    100% {
        -moz-transform: scale(1);
        transform: scale(1);
        opacity: 0;
    }
}

@keyframes homeTipTwo {
    0% {
        -o-transform: scale(0);
        transform: scale(0);
        opacity: 1;
    }

    100% {
        -o-transform: scale(0.6);
        transform: scale(0.6);
        opacity: 0;
    }
}

@media (max-width:768px) {
    .codics-home-card {
        width: 100%;
        margin-left: unset !important;
        margin-bottom: 15px;
    }
    .codics-home-totop-box{
        right: 20px !important;
        bottom: 20px !important;
    }
}
</style>